import NetInfo from '@react-native-community/netinfo'
import { focusManager, onlineManager } from '@tanstack/react-query'
import { useEffect } from 'react'
import { AppState, Platform } from 'react-native'
import type { AppStateStatus } from 'react-native'

const onAppStateChange = (status: AppStateStatus) => {
	if (Platform.OS !== 'web') {
		focusManager.setFocused(status === 'active')
	}
}

const AppQueryRefresher = ({ children }: { children: React.ReactNode }) => {
	onlineManager.setEventListener((setOnline) => {
		return NetInfo.addEventListener((state) => {
			setOnline(!!state.isConnected)
		})
	})

	useEffect(() => {
		const subscription = AppState.addEventListener('change', onAppStateChange)

		return () => subscription.remove()
	}, [])

	return children
}

export { AppQueryRefresher }
